import { useEffect } from 'react';
import { useApp } from '@/store';

export function TourBoot() {
  const seen = useApp(s => s.tourSeen);
  const startTour = useApp(s => s.startTour);
  const user = useApp(s => s.currentUser);

  useEffect(() => {
    if (seen) return;
    if (!user) return;
    const id = setTimeout(() => startTour(), 600);
    return () => clearTimeout(id);
  }, [seen, startTour, user]);

  return null;
}
